export default "__VITE_ASSET__BqCM5Up0__"